/* eslint-disable */
import MainCard from "components/MainCard";
import { useEffect, useState } from "react";
import ECharts from 'echarts-for-react';
import { useTheme } from "components/ThemeContext";

const chartDataInit = {
  tooltip: {
    trigger: 'axis',
    axisPointer: {
      type: 'cross'
    }
  },
  legend: {
    textStyle : {
      color : '#fff'
    },
    // data: ['Email', 'Union Ads', 'Video Ads', 'Direct', 'Search Engine']
  },
  xAxis : { 
    type: 'category',
    // axisTick: { show: false },
    boundaryGap: false,
    // data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
  },
  yAxis : {
    type: 'value'
  },
  series: []
}

export function DashboardAreaStackChart({barData, widthSize=600}) {
  const [isLoading, setIsLoading] = useState(false);
  const [options, setOptions] = useState(chartDataInit);
  const { mode } = useTheme();

  useEffect(()=>{
    if (isLoading) {
      setIsLoading(false);
    }
    if (barData) {
      let optionsCopy = {...chartDataInit};
      let chartDataCopy = JSON.parse(JSON.stringify(optionsCopy));
      chartDataCopy.xAxis.data = barData.categories;
      chartDataCopy.legend.data = barData.legends;
      chartDataCopy.legend.textStyle.color = (mode === 'white' ? "#000" : "#fff");

      barData && barData.series.map(function(seris, k) {
        // console.log(seris)
        seris.map(function(series) {
          // console.log(series)
          chartDataCopy.series.push(
            { name: series.name, 
              data: series.data, 
              areaStyle: {},
              // itemStyle: series.itemStyle,
              stack: 'Total',
              type: 'line',
              // label:{ position :'inside'}, 
              // barGap: 0, 
              emphasis: { focus: 'series' }, }
          );
        })
        // chartDataCopy.series.push(
        //   { name: seris.name, 
        //     data: seris.data, 
        //     stack: seris.name,
        //     type: 'bar', 
        //     label:{ position :'inside'}, 
        //     barGap: 0, 
        //     emphasis: { focus: 'series' }, }
        // );
      })
      // barData && barData.series.map(function(seris, k) {
      //   chartDataCopy.series.push({ name: seris.name, data: seris.data, type: 'bar', label:{ position :'inside'}, barGap: 0, emphasis: { focus: 'series' }, });
      // })
      // console.log(chartDataCopy)
      setOptions(chartDataCopy);
      setIsLoading(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[barData, isLoading, mode]);

  // 클릭 이벤트 핸들러
  const onChartClick = (params) => {
    // console.log(params)
    if (params.data.link) {
      window.open(params.data.link, '_self');
    }
  };

  if (isLoading) {
    return (
      <div className="mixed-chart mixed-chart1">
          <MainCard content={false}>
            <ECharts
              option={options}
              opts={{ renderer: 'svg', width: widthSize+'px', height: '250px' }}
              onEvents={{
                click: onChartClick,
              }}
            />
          </MainCard>
      </div>
    )
  }
}

export default DashboardAreaStackChart;
